import { render } from "./ColorWheel.vue?vue&type=template&id=350e7a99&scoped=true"
import script from "./ColorWheel.vue?vue&type=script&lang=js"
export * from "./ColorWheel.vue?vue&type=script&lang=js"

import "./ColorWheel.vue?vue&type=style&index=0&id=350e7a99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350e7a99"]])

export default __exports__